module.exports = __webpack_public_path__ + "img/6.4f2df8d7.png";